import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const usePageRestriction = (redirectWhen: 'authenticated' | 'unauthenticated', redirectTo: string, isAuthenticated?: boolean) => {
   const navigate = useNavigate();
   useEffect(() => {
      if (isAuthenticated === undefined) return;
      if (isAuthenticated && redirectWhen === 'unauthenticated') {
         navigate(redirectTo);
         return;
      }
      if (!isAuthenticated && redirectWhen === 'authenticated') {
         navigate(redirectTo);
         return;
      }
   }, [isAuthenticated]);
};
